import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Check, ChevronDown } from 'lucide-react'

/**
 * Select — value picker built on a NON-MODAL Radix DropdownMenu (RadioGroup).
 * Closed trigger keeps the system look (class `.select`); the open list is a
 * styled popup with keyboard nav, typeahead and a check on the selected item.
 *
 * Non-modal on purpose: unlike Radix Select (which is hardwired modal and kills
 * pointer-events on the page), a non-modal menu doesn't block the page, so the
 * click that closes it never leaks to a parent overlay (peek/Modal) as an
 * "outside click". That removes the need for any cross-layer guard.
 */
export function Select({
  value,
  onValueChange,
  options = [],
  placeholder,
  className = '',
  disabled,
  title,
  'aria-label': ariaLabel
}) {
  const triggerCls = ['select', className].filter(Boolean).join(' ')
  const selected = options.find((opt) => opt.value === value)
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger className={triggerCls} aria-label={ariaLabel} title={title} disabled={disabled}>
        <span className="select-value" data-placeholder={selected ? undefined : ''}>
          {selected ? selected.label : placeholder}
        </span>
        <span className="select-caret">
          <ChevronDown size={16} />
        </span>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className="select-content" align="start" sideOffset={4}>
          <DropdownMenu.RadioGroup value={value} onValueChange={onValueChange}>
            {options.map((opt) => (
              <DropdownMenu.RadioItem key={opt.value} value={opt.value} className="select-item">
                <span>{opt.label}</span>
                <DropdownMenu.ItemIndicator className="select-check">
                  <Check size={15} />
                </DropdownMenu.ItemIndicator>
              </DropdownMenu.RadioItem>
            ))}
          </DropdownMenu.RadioGroup>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
